import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export function TableData(props: { children: React.ReactNode; title?: string }) {
  return (
    <Box title={props.title} sx={{ textAlign: "center" }}>
      <Typography variant="h4" component="span">
        {props.children}
      </Typography>
    </Box>
  );
}
export function TableHead(props: { children: React.ReactNode; title?: string }) {
  return (
    <Box title={props.title} sx={{ textAlign: "center" }}>
      <Typography variant="caption" component="div">
        <Box
          component="span"
          sx={{
            fontSize: 12,
            fontWeight: "fontWeightRegular",
          }}
        >
          {props.children}
        </Box>
      </Typography>
    </Box>
  );
}
